import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Reveal, SectionHeading } from "../components/Reveal";
import { AbstractVisual } from "../components/AbstractVisual";
import { api } from "../lib/api";

export default function Insights() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("All");

  useEffect(() => { api.list("news").then(setItems).catch(() => {}); }, []);

  const cats = ["All", ...new Set(items.map((a) => a.category))];
  const shown = cat === "All" ? items : items.filter((a) => a.category === cat);

  return (
    <main className="pt-40 pb-28">
      <Seo title="Insights" path="/insights"
        description="XR industry insights, company news, new experiences, technology and behind the scenes from Vrova — immersive entertainment company India." />
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <SectionHeading overline="News & Insights" title={<>Notes From <span className="italic text-zinc-400">the Frontier.</span></>} />
        <Reveal delay={0.15} className="mt-10">
          <div className="flex flex-wrap gap-2.5" data-testid="insights-filters">
            {cats.map((c) => (
              <button key={c} onClick={() => setCat(c)} data-testid={`insight-filter-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={`px-5 py-2.5 rounded-full text-xs font-mono uppercase tracking-[0.15em] transition-all duration-300 ${cat === c ? "bg-white text-black" : "border border-white/15 text-zinc-400 hover:text-white"}`}>
                {c}
              </button>
            ))}
          </div>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14" data-testid="insights-grid">
          {shown.map((a, i) => (
            <Reveal key={a.id} delay={(i % 3) * 0.07}>
              <Link to={`/insights/${a.slug}`} data-testid={`insight-card-${a.slug}`}
                className="group block rounded-2xl border border-white/10 bg-white/[0.02] overflow-hidden hover:border-white/25 hover:-translate-y-1.5 transition-all duration-500 h-full">
                <div className="relative h-48"><AbstractVisual hue={a.hue ?? 222} seed={i * 11 + 5} /></div>
                <div className="p-8">
                  <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500 mb-3">{a.category} · {a.date}</p>
                  <h3 className="font-serif text-xl md:text-2xl leading-snug mb-3 group-hover:text-white text-zinc-100 transition-colors">{a.title}</h3>
                  <p className="text-sm text-zinc-500 font-light leading-relaxed line-clamp-3">{a.excerpt}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
}
